import React from "react"
import { Form, Col, Row, Button, Container } from "react-bootstrap"
import { FaAngleDoubleDown, FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleDoubleUp, FaAngleDown, FaAngleUp, FaChevronLeft, FaChevronRight } from "react-icons/fa"
import _lodash from "lodash"

interface DualListBoxProps<T> {
  disabled?: boolean
  idKey?: keyof T
  labelKey?: keyof T
  options: T[]
  selected: T[]
  availableTitle: string
  selectedTitle: string
  onChange: (selected: T[]) => void
  isConsortium?: boolean
}

interface DualListBoxState<T> {
  selected: T[]
  selectionLeft: string[]
  selectionRight: string[]
}

export default class DualListBox<T> extends React.PureComponent<DualListBoxProps<T>, DualListBoxState<T>> {
  state = { selected: this.mapOptions(this.props.selected), selectionLeft: [], selectionRight: [] }

  mapOption(option: any): any {
    return this.props.idKey ? option[this.props.idKey].toString() : option
  }

  mapOptions(options: any[]): any[] {
    return this.props.idKey ? options.map(option => option[this.props.idKey].toString()) : options
  }

  optionLabel(option: any): any {
    return this.props.labelKey ? option[this.props.labelKey] + (!!option.DisableMessage ? " ("+option.DisableMessage+")" : "") : option
  }

  disabledOption(option: any): boolean {
    return !!option.DisableMessage
  }

  optionTitle(option: any): any {
    return !!option.DisableMessage ? option.DisableMessage : ""
  }

  componentDidUpdate(prevProps: DualListBoxProps<T>, prevState: DualListBoxState<T>) {
    if (!_lodash.isEqual(this.props.selected, prevProps.selected)) {
      const selection = this.mapOptions(this.props.selected)
      this.setState({ selected: selection })
    }
    if (!_lodash.isEqual(this.state.selected, prevState.selected)) {
      const selection = this.props.options.filter(option => this.state.selected.includes(this.mapOption(option)))
      this.props.onChange(selection)
    }
  }

  move(dir: "ltr" | "rtl", all?: boolean) {
    const selectionRight: string[] =  this.state.selectionRight
    let newSelection = [];
    if (dir === "ltr") 
    {
      newSelection = this.mapOptions(this.props.options.filter(o => !this.disabledOption(o))); 
    } 

    if (!all)
    {
      newSelection = [...this.state.selected, ...this.state.selectionLeft]
      if (dir === "rtl")
      {
        newSelection = this.state.selected.filter(option => !selectionRight.includes(option))
      } 
    }
    dir === "ltr" ? this.setState({ selectionLeft: [], selected: newSelection }) : this.setState({ selectionRight: [], selected: newSelection })
  }

  render() {
    const options: T[] = this.props.options
    const selection: string[] = this.state.selected
    const availableOptions = options.filter(option => !selection.includes(this.mapOption(option)))
    const selectedOptions = options.filter(option => selection.includes(this.mapOption(option)))
    return (
      <>
        <Row className="d-none d-lg-flex">
          <Col lg={5}>{this.props.availableTitle}</Col>
          <Col className="px-0"></Col>
          <Col lg={5} className="pl-lg-0">{this.props.selectedTitle}</Col>
        </Row>
        <Row>
          <Col lg={5} className="pr-lg-0">
            <div className="d-lg-none">{this.props.availableTitle}</div>
            <Form.Control as="select" multiple style={{ height: "152px" }}
              disabled={this.props.disabled}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ selectionLeft: Array.from(e.target.selectedOptions, option => option.value) }) }}>
              { availableOptions.map(option => <option key={this.mapOption(option)} value={this.mapOption(option)} disabled={this.disabledOption(option)} title={this.optionTitle(option)}>{this.optionLabel(option)}</option>) }
            </Form.Control>
          </Col>
          <Col className="px-0">
            <Container fluid>
              <Row>
                <Col lg={12} xs={3} className="px-1 text-center">
                  <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!availableOptions.length || this.props.disabled || this.props.isConsortium}
                    onClick={ () => this.move("ltr", true) }>
                    <FaAngleDoubleRight className="d-none d-lg-inline" />
                    <FaAngleDoubleDown className="d-lg-none" />
                  </Button>
                </Col>
                <Col lg={12} xs={3} className="px-1 text-center">
                  <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!this.state.selectionLeft.length || this.props.disabled}
                      onClick={ () => this.move("ltr") }>
                    <FaChevronRight className="d-none d-lg-inline" />
                    <FaAngleDown className="d-lg-none" />
                  </Button>
                </Col>
                <Col lg={12} xs={3} className="px-1 text-center">
                  <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1" disabled={!this.state.selectionRight.length || this.props.disabled}
                      onClick={() => this.move("rtl")}>
                    <FaChevronLeft className="d-none d-lg-inline" />
                    <FaAngleUp className="d-lg-none" />
                  </Button>
                </Col>
                <Col lg={12} xs={3} className="px-1 text-center">
                  <Button className="btn-sm btn-sm-icon mb-lg-2 mt-lg-0 my-1"  disabled={!selectedOptions.length || this.props.disabled || this.props.isConsortium}
                    onClick={() => this.move("rtl", true)}>
                    <FaAngleDoubleLeft className="d-none d-lg-inline" />
                    <FaAngleDoubleUp className="d-lg-none" />
                  </Button>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col lg={5} className="pl-lg-0">
            <div className="d-lg-none">{this.props.selectedTitle}</div>
            <Form.Control as="select" multiple style={{ height: "152px" }} disabled={this.props.disabled}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ selectionRight: Array.from(e.target.selectedOptions, option => option.value) }) }}>
              { selectedOptions.map(option => <option key={this.mapOption(option)} value={this.mapOption(option)}>{this.optionLabel(option)}</option>) }
            </Form.Control>
          </Col>
        </Row>
      </>
    )
  }

  static defaultProps = { selected: [], availableTitle: "Available", selectedTitle: "Selected", disabledkeys: [] }
}
